import { g as __rest, b as __assign } from '../../../../_tslib-7a01aab4.js';
import React from 'react';

var ListHeader = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (React.createElement("div", { className: 'top-of-lists-wrapper' },
        React.createElement("div", __assign({ className: 'lists-title-row' }, rest), children)));
};

export { ListHeader };
